<template>
  <div class="main-block transactions">
    <div class="details-component__header" v-on:click="toggleSection">
      <span>
        <h1>{{ $t('payment.transactions') }}</h1>
      </span>
      <div class="details-component__header_right">
        <div :class="!showSection ? toggleIconDown : toggleIconUp"/>
      </div>
    </div>
    <div v-show="showSection">
      <div class="header">
        <div class="period-container">
          <div class="period__title">{{ $t('payment.current_period') }}:</div>
          <div class="period__time">
            01/{{ dates.months.cur + 1 }}/{{ dates.years.cur }} -
            {{ dates.daysInCurMonth }}/{{ dates.months.cur + 1 }}/{{ dates.years.cur }}
          </div>
        </div>
        <div class="form__buttons buttonset">
          <div class="buttonset__button btn btn--secondary"
               @click="calculateMonth('prev')">
            {{ $t('payment.prev_month') }}
          </div>
          <div class="buttonset__button btn btn--secondary"
               @click="calculateMonth('next')">
            {{ $t('payment.next_month') }}
          </div>
        </div>
      </div>

      <div v-if="!this.isLoadingTransactions" class="report-info">
        <div v-if="transactions.data.length > 0">

          <div class="desktop-view head">
            <div>{{ $t('common.vehicle_reg') }}</div>
            <div>{{ $t('common.zone') }}</div>
            <div>{{ $t('common.start') }}</div>
            <div>{{ $t('common.stop') }}</div>
            <div>{{ $t('pricingrules.price') }}</div>
            <div>{{ $t('nav.payment') }}</div>
            <div class="receipt-col-header">{{ $t('common.receipt') }}</div>
          </div>

          <div v-for="transaction in transactions.data">

            <!-- desktop view -->

            <div class="desktop-view row">
              <div class="car-number">
                <div class="icon-car-grey"></div>
                <div>{{ transaction.parking.vehicle_reg }}</div>
              </div>
              <div>
                <div class="parking-info">
                  {{ transaction.sale_date }}: {{ transaction.parking.product.name }}
                </div>
              </div>
              <div class="d-flex">
                <div class="icon-start-green"></div>
                <div>{{ getTime(transaction.parking.start_time) }}</div>
              </div>
              <div class="d-flex">
                <div class="icon-stop-red"></div>
                <div>{{ getTime(transaction.parking.end_time) }}</div>
              </div>
              <div>{{ transaction.amount }}</div>
              <div>
                {{ transaction.payment_method ? transaction.payment_method.payment_method : '-' }}
                {{
                  transaction.payment_method ? transaction.payment_method.masked_pan.substr(transaction.payment_method.masked_pan.length - 7) : '-'
                }}
              </div>
              <div class="receipt-download">
                <a :href="receiptUrl(transaction.uuid)">
                  <div class="icon-download"></div>
                </a>
              </div>
            </div>

            <!-- mobile view -->

            <div class="mob-view row" @click="toggleReport(transaction.uuid)">
              <div class="car-number">
                <div class="icon-car-grey"></div>
                <div>{{ transaction.parking.vehicle_reg }}</div>
              </div>
              <div class="info">
                <div class="parking-info">
                  {{ transaction.sale_date }}: {{ transaction.parking.product.name }}
                </div>
                <div class="total">{{ transaction.amount }}</div>
                <div :id="'up-' + transaction.uuid" :class="toggleIconUp" style="margin-top: -7px; display: none"/>
                <div :id="'down-' + transaction.uuid" :class="toggleIconDown" style="margin-top: -7px; display: block"/>
              </div>
              <div class="details" :id="transaction.uuid">
                <div class="end-start-time">
                  <div class="start d-flex">
                    <div class="icon-start-green"></div>
                    <div>{{ getTime(transaction.parking.start_time) }}</div>
                  </div>
                  <div class="end d-flex">
                    <div class="icon-stop-red"></div>
                    <div>{{ getTime(transaction.parking.end_time) }}</div>
                  </div>
                  <div class="d-flex" style="justify-content: space-between">
                    <div class="payment-card">
                      <div>{{ transaction.payment_method ? transaction.payment_method.payment_method : '-' }} {{
                          transaction.payment_method ? transaction.payment_method.masked_pan.substr(transaction.payment_method.masked_pan.length - 7) : '-'
                        }}
                      </div>
                    </div>
                    <div class="mob-receipt-download d-flex" @click="stayBlockOpened()">
                      <a :href="receiptUrl(transaction.uuid)">
                        <div class="icon-download"></div>
                        <div class="receipt-text">{{ $t('common.receipt') }}</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list-widget__footer items-container__footer">
            <slot name="footer">
              <div v-if="!this.isExtendingLimitLoading">
                <a
                  class="link"
                  v-on:click.stop.prevent="extendLimit()"
                  v-if="transactions.meta.last_page > transactions.meta.current_page"
                >{{ $t('common.load_more') }}
                </a>
              </div>
              <div v-else>...</div>
            </slot>

          </div>

        </div>
        <div v-else class="not-found">{{ $t('payment.not_found') }}</div>
      </div>
      <div v-else class="loader-bubbles"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment/moment";

export default {
  data() {
    return {
      currency_short: process.env.CURRENCY_SHORT,
      date_time_format: 'DD.MM.YYYY HH:mm',
      showSection: false,
      toggleIconDown: 'icon icon-bl-arrow-down',
      toggleIconUp: 'icon icon-bl-arrow-up',
      stayOpened: false
    }
  },
  computed: {
    ...mapGetters({
      transactions: 'payment/cards/transactions',
      isLoadingTransactions: 'payment/cards/isLoadingTransactions',
      isExtendingLimitLoading: 'payment/cards/isExtendingLimitLoading',
      dates: 'payment/cards/dates'
    })
  },
  mounted() {
    if (!this.isLoadingTransactions) {
      let curMonth = this.calculateMonthDates(this.dates.months.cur, this.dates.years.cur)
      this.fetchMonthTransactions(curMonth, 0)
    }
  },
  methods: {
    getTime(time) {
      return moment(time).format('DD.MM HH:mm');
    },
    toggleReport(id) {
      if (this.stayOpened) {
        this.stayOpened = false
        return
      }
      let elemStyle = document.getElementById(id).style;
      let iconUp = document.getElementById('up-' + id)
      let iconDown = document.getElementById('down-' + id)
      if (elemStyle.display === 'none' || elemStyle.display === '') {
        elemStyle.display = 'flex'
        iconDown.style.display = 'none'
        iconUp.style.display = 'block'
      } else {
        elemStyle.display = 'none'
        iconDown.style.display = 'block'
        iconUp.style.display = 'none'
      }
    },
    stayBlockOpened() {
      this.stayOpened = true
    },
    calculateMonthDates(startMonth, startYear) {
      let curDate = new Date();
      if (startMonth > -1 && startYear > 0) {
        curDate = new Date(startYear, startMonth);
      }
      let curMonth = curDate.getMonth()
      let curYear = curDate.getFullYear()
      curDate.setMonth(curDate.getMonth() + 1)
      let nextMonth = curDate.getMonth()
      let nextYear = curDate.getFullYear()
      curDate.setMonth(curDate.getMonth() - 2)
      let prevMonth = curDate.getMonth()
      let prevYear = curDate.getFullYear()

      this.$store.dispatch('payment/cards/setDates', {
        months: {
          prev: prevMonth,
          cur: curMonth,
          next: nextMonth
        },
        years: {
          prev: prevYear,
          cur: curYear,
          next: nextYear
        },
        daysInCurMonth: new Date(this.dates.months.cur + 1, this.dates.years.cur, 0).getDate()
      })
      return this.dates.months.cur
    },
    calculateMonth(direction) {
      let curMonth = this.calculateMonthDates(this.dates.months[direction], this.dates.years[direction])
      this.fetchMonthTransactions(curMonth, 0)
    },
    fetchMonthTransactions(curMonth, pageNr) {
      this.$store.dispatch('payment/cards/fetchTransactions', {
        month: curMonth + 1,
        year: this.dates.years.cur,
        page: pageNr + 1
      })
    },
    extendLimit() {
      this.fetchMonthTransactions(this.dates.months.cur, this.transactions.meta.current_page)
    },
    toggleSection() {
      this.showSection = !this.showSection
    },
    receiptUrl(transactionId) {
      return `${process.env.BACKEND_API_URL}payment/transactions/${transactionId}/receipt/` +
        `?locale=${localStorage.getItem('locale')}` +
        `&token=${localStorage.getItem('id_token')}`
    }
  }
}
</script>

<style lang="scss" scoped>

@import '../../../styles/spinner';
@import '../../../styles/app';
@import '../assets/styles/payment';

</style>



// WEBPACK FOOTER //
// src/components/payment/features/Transactions.vue